// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file note/note.proto (package lvdr.v2.note, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AiMark } from "../common/aimark_pb";
import { file_common_aimark } from "../common/aimark_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file note/note.proto.
 */
export const file_note_note: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_aimark]);

/**
 * Domain models
 *
 * @generated from message lvdr.v2.note.Note
 */
export type Note = Message<"lvdr.v2.note.Note"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string folder_id = 2;
   */
  folderId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: repeated lvdr.v2.note.NoteLink links = 5;
   */
  links: NoteLink[];

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @generated from field: bool pinned = 7;
   */
  pinned: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * Optimistic-concurrency token. Server increments on every successful
   * update; legacy notes report 1 (NormalizeVersion, mirroring workspace
   * notes). 0 on the wire from old clients means "no CAS" (LWW).
   *
   * @generated from field: int32 version = 10;
   */
  version: number;

  /**
   * Soft delete (trash). Set ⇒ the note is in the trash; excluded from
   * default lists. Hard-purged 30 days after this timestamp.
   *
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */
  deletedAt?: Timestamp | undefined;

  /**
   * NOTES-21: the write_token of the last payload write that landed (an
   * UpdateNote of any field, a soft delete, a folder delete's move); "" when
   * that writer sent none. Link and unlink keep it. The web outbox reads it on a stale
   * reply to tell its own landed write from another writer's.
   *
   * @generated from field: string last_write_token = 12;
   */
  lastWriteToken: string;

  /**
   * True when LumaVista's own model wrote any of this note's text. Sticky.
   *
   * @generated from field: bool contains_ai_text = 13;
   */
  containsAiText: boolean;

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 14;
   */
  aiMark?: AiMark | undefined;
};

/**
 * Describes the message lvdr.v2.note.Note.
 * Use `create(NoteSchema)` to create a new message.
 */
export const NoteSchema: GenMessage<Note> = /*@__PURE__*/
  messageDesc(file_note_note, 0);

/**
 * @generated from message lvdr.v2.note.NoteFolder
 */
export type NoteFolder = Message<"lvdr.v2.note.NoteFolder"> & {
  /**
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.note.NoteFolder.
 * Use `create(NoteFolderSchema)` to create a new message.
 */
export const NoteFolderSchema: GenMessage<NoteFolder> = /*@__PURE__*/
  messageDesc(file_note_note, 1);

/**
 * @generated from message lvdr.v2.note.NoteLink
 */
export type NoteLink = Message<"lvdr.v2.note.NoteLink"> & {
  /**
   * @generated from field: string target_type = 1;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 2;
   */
  targetId: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: lvdr.v2.note.LinkOrigin origin = 4;
   */
  origin: LinkOrigin;
};

/**
 * Describes the message lvdr.v2.note.NoteLink.
 * Use `create(NoteLinkSchema)` to create a new message.
 */
export const NoteLinkSchema: GenMessage<NoteLink> = /*@__PURE__*/
  messageDesc(file_note_note, 2);

/**
 * Note CRUD requests
 *
 * @generated from message lvdr.v2.note.CreateNoteRequest
 */
export type CreateNoteRequest = Message<"lvdr.v2.note.CreateNoteRequest"> & {
  /**
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * template_note_id names the Templates-folder note this create copies (CHAT-50).
   * "" = not a template copy. The server derives the copy's provenance stamp from it.
   *
   * @generated from field: string template_note_id = 4;
   */
  templateNoteId: string;
};

/**
 * Describes the message lvdr.v2.note.CreateNoteRequest.
 * Use `create(CreateNoteRequestSchema)` to create a new message.
 */
export const CreateNoteRequestSchema: GenMessage<CreateNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 3);

/**
 * @generated from message lvdr.v2.note.GetNoteRequest
 */
export type GetNoteRequest = Message<"lvdr.v2.note.GetNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;
};

/**
 * Describes the message lvdr.v2.note.GetNoteRequest.
 * Use `create(GetNoteRequestSchema)` to create a new message.
 */
export const GetNoteRequestSchema: GenMessage<GetNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 4);

/**
 * @generated from message lvdr.v2.note.UpdateNoteRequest
 */
export type UpdateNoteRequest = Message<"lvdr.v2.note.UpdateNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string | undefined;

  /**
   * @generated from field: optional string content = 3;
   */
  content?: string | undefined;

  /**
   * @generated from field: optional string folder_id = 4;
   */
  folderId?: string | undefined;

  /**
   * @generated from field: optional bool pinned = 5;
   */
  pinned?: boolean | undefined;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * CAS token: when > 0 the server only applies the update if the stored
   * version matches; on mismatch it returns the CURRENT note with
   * NoteResponse.stale_version=true and writes nothing. 0 = legacy LWW.
   *
   * @generated from field: int32 expected_version = 7;
   */
  expectedVersion: number;

  /**
   * Restore a trashed note (clears deleted_at). Other fields are still
   * applied; send the current entity state as usual.
   *
   * @generated from field: bool restore = 8;
   */
  restore: boolean;

  /**
   * NOTES-22: true ⇒ an absent optional field above means "leave unchanged",
   * and tags are replaced iff has_tags (empty tags with has_tags clears them).
   * false — every client built before NOTES-22 — keeps the old reading: every
   * scalar is applied from its getter and tags apply only when non-empty.
   *
   * @generated from field: bool explicit_presence = 9;
   */
  explicitPresence: boolean;

  /**
   * Read only when explicit_presence is true.
   *
   * @generated from field: bool has_tags = 10;
   */
  hasTags: boolean;

  /**
   * NOTES-21: the sender's per-episode write token (one random id per outbox
   * entry). Stored on the note by a write that lands and echoed as
   * Note.last_write_token. "" = a writer with no episode (every client built
   * before NOTES-21) or a send that is not an episode write (the web's
   * restore-only send). MCP and chat do not send this message; their writes
   * clear the stored token too. Opaque: the server never parses it.
   *
   * @generated from field: string write_token = 11;
   */
  writeToken: string;

  /**
   * This save carries text the client inserted from an AI tool.
   *
   * @generated from field: bool ai_text_inserted = 12;
   */
  aiTextInserted: boolean;
};

/**
 * Describes the message lvdr.v2.note.UpdateNoteRequest.
 * Use `create(UpdateNoteRequestSchema)` to create a new message.
 */
export const UpdateNoteRequestSchema: GenMessage<UpdateNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 5);

/**
 * @generated from message lvdr.v2.note.DeleteNoteRequest
 */
export type DeleteNoteRequest = Message<"lvdr.v2.note.DeleteNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * false (default) = soft delete to trash; true = hard delete (used from
   * the trash view's "Delete forever").
   *
   * @generated from field: bool permanent = 2;
   */
  permanent: boolean;
};

/**
 * Describes the message lvdr.v2.note.DeleteNoteRequest.
 * Use `create(DeleteNoteRequestSchema)` to create a new message.
 */
export const DeleteNoteRequestSchema: GenMessage<DeleteNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 6);

/**
 * @generated from message lvdr.v2.note.ListNotesRequest
 */
export type ListNotesRequest = Message<"lvdr.v2.note.ListNotesRequest"> & {
  /**
   * empty = all notes
   *
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * Include trashed notes (deleted_at set) in the response. The trash view
   * sets this; default lists exclude them.
   *
   * @generated from field: bool include_deleted = 2;
   */
  includeDeleted: boolean;
};

/**
 * Describes the message lvdr.v2.note.ListNotesRequest.
 * Use `create(ListNotesRequestSchema)` to create a new message.
 */
export const ListNotesRequestSchema: GenMessage<ListNotesRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 7);

/**
 * ListNotesByLinkRequest returns every note in the user's store whose
 * Links contain a matching (target_type, target_id) pair. Powers the
 * "Notes from this <thing>" inline panel (e.g. RecordingPlayer).
 *
 * @generated from message lvdr.v2.note.ListNotesByLinkRequest
 */
export type ListNotesByLinkRequest = Message<"lvdr.v2.note.ListNotesByLinkRequest"> & {
  /**
   * "recording", "research", "document", "chat", "note"
   *
   * @generated from field: string target_type = 1;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 2;
   */
  targetId: string;
};

/**
 * Describes the message lvdr.v2.note.ListNotesByLinkRequest.
 * Use `create(ListNotesByLinkRequestSchema)` to create a new message.
 */
export const ListNotesByLinkRequestSchema: GenMessage<ListNotesByLinkRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 8);

/**
 * @generated from message lvdr.v2.note.ListNotesByLinkResponse
 */
export type ListNotesByLinkResponse = Message<"lvdr.v2.note.ListNotesByLinkResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.note.NoteRef notes = 1;
   */
  notes: NoteRef[];
};

/**
 * Describes the message lvdr.v2.note.ListNotesByLinkResponse.
 * Use `create(ListNotesByLinkResponseSchema)` to create a new message.
 */
export const ListNotesByLinkResponseSchema: GenMessage<ListNotesByLinkResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 9);

/**
 * NoteRef is a lightweight (id, title) projection — enough to render
 * a clickable list without shipping full Note bodies.
 *
 * @generated from message lvdr.v2.note.NoteRef
 */
export type NoteRef = Message<"lvdr.v2.note.NoteRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message lvdr.v2.note.NoteRef.
 * Use `create(NoteRefSchema)` to create a new message.
 */
export const NoteRefSchema: GenMessage<NoteRef> = /*@__PURE__*/
  messageDesc(file_note_note, 10);

/**
 * Note responses
 *
 * @generated from message lvdr.v2.note.NoteResponse
 */
export type NoteResponse = Message<"lvdr.v2.note.NoteResponse"> & {
  /**
   * @generated from field: lvdr.v2.note.Note note = 1;
   */
  note?: Note | undefined;

  /**
   * Set when an update carried expected_version and it did not match the
   * stored version. `note` then holds the CURRENT server state (nothing was
   * written) — same 200-with-flag shape as WorkspaceNoteResponse.
   *
   * @generated from field: bool stale_version = 2;
   */
  staleVersion: boolean;
};

/**
 * Describes the message lvdr.v2.note.NoteResponse.
 * Use `create(NoteResponseSchema)` to create a new message.
 */
export const NoteResponseSchema: GenMessage<NoteResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 11);

/**
 * GetOrCreateDailyNoteRequest opens today's daily note, creating it from the
 * user's `Templates/daily` template when it does not exist (CHAT-47). The
 * server resolves "today" in the user's settings zone, else client_timezone
 * (IANA name, ≤64 chars, validated server-side), else server local time.
 * The reply is a NoteResponse.
 *
 * @generated from message lvdr.v2.note.GetOrCreateDailyNoteRequest
 */
export type GetOrCreateDailyNoteRequest = Message<"lvdr.v2.note.GetOrCreateDailyNoteRequest"> & {
  /**
   * @generated from field: string client_timezone = 1;
   */
  clientTimezone: string;
};

/**
 * Describes the message lvdr.v2.note.GetOrCreateDailyNoteRequest.
 * Use `create(GetOrCreateDailyNoteRequestSchema)` to create a new message.
 */
export const GetOrCreateDailyNoteRequestSchema: GenMessage<GetOrCreateDailyNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 12);

/**
 * @generated from message lvdr.v2.note.NoteListResponse
 */
export type NoteListResponse = Message<"lvdr.v2.note.NoteListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.note.Note notes = 1;
   */
  notes: Note[];
};

/**
 * Describes the message lvdr.v2.note.NoteListResponse.
 * Use `create(NoteListResponseSchema)` to create a new message.
 */
export const NoteListResponseSchema: GenMessage<NoteListResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 13);

/**
 * DeleteNoteResponse acks a successful delete by id. It is deliberately
 * distinct from NoteResponse: the FE removes strictly by note_id, so the
 * ack can never be mistaken for an upsert (which would resurrect the note
 * as a sparse "Untitled" row).
 *
 * @generated from message lvdr.v2.note.DeleteNoteResponse
 */
export type DeleteNoteResponse = Message<"lvdr.v2.note.DeleteNoteResponse"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;
};

/**
 * Describes the message lvdr.v2.note.DeleteNoteResponse.
 * Use `create(DeleteNoteResponseSchema)` to create a new message.
 */
export const DeleteNoteResponseSchema: GenMessage<DeleteNoteResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 14);

/**
 * Folder CRUD requests
 *
 * @generated from message lvdr.v2.note.CreateNoteFolderRequest
 */
export type CreateNoteFolderRequest = Message<"lvdr.v2.note.CreateNoteFolderRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string parent_id = 2;
   */
  parentId: string;
};

/**
 * Describes the message lvdr.v2.note.CreateNoteFolderRequest.
 * Use `create(CreateNoteFolderRequestSchema)` to create a new message.
 */
export const CreateNoteFolderRequestSchema: GenMessage<CreateNoteFolderRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 15);

/**
 * @generated from message lvdr.v2.note.UpdateNoteFolderRequest
 */
export type UpdateNoteFolderRequest = Message<"lvdr.v2.note.UpdateNoteFolderRequest"> & {
  /**
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string parent_id = 3;
   */
  parentId?: string | undefined;

  /**
   * @generated from field: optional int32 sort_order = 4;
   */
  sortOrder?: number | undefined;

  /**
   * NOTES-22: same contract as UpdateNoteRequest.explicit_presence.
   *
   * @generated from field: bool explicit_presence = 5;
   */
  explicitPresence: boolean;
};

/**
 * Describes the message lvdr.v2.note.UpdateNoteFolderRequest.
 * Use `create(UpdateNoteFolderRequestSchema)` to create a new message.
 */
export const UpdateNoteFolderRequestSchema: GenMessage<UpdateNoteFolderRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 16);

/**
 * @generated from message lvdr.v2.note.DeleteNoteFolderRequest
 */
export type DeleteNoteFolderRequest = Message<"lvdr.v2.note.DeleteNoteFolderRequest"> & {
  /**
   * @generated from field: string folder_id = 1;
   */
  folderId: string;
};

/**
 * Describes the message lvdr.v2.note.DeleteNoteFolderRequest.
 * Use `create(DeleteNoteFolderRequestSchema)` to create a new message.
 */
export const DeleteNoteFolderRequestSchema: GenMessage<DeleteNoteFolderRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 17);

/**
 * @generated from message lvdr.v2.note.ListNoteFoldersRequest
 */
export type ListNoteFoldersRequest = Message<"lvdr.v2.note.ListNoteFoldersRequest"> & {
};

/**
 * Describes the message lvdr.v2.note.ListNoteFoldersRequest.
 * Use `create(ListNoteFoldersRequestSchema)` to create a new message.
 */
export const ListNoteFoldersRequestSchema: GenMessage<ListNoteFoldersRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 18);

/**
 * @generated from message lvdr.v2.note.NoteFolderResponse
 */
export type NoteFolderResponse = Message<"lvdr.v2.note.NoteFolderResponse"> & {
  /**
   * @generated from field: lvdr.v2.note.NoteFolder folder = 1;
   */
  folder?: NoteFolder | undefined;
};

/**
 * Describes the message lvdr.v2.note.NoteFolderResponse.
 * Use `create(NoteFolderResponseSchema)` to create a new message.
 */
export const NoteFolderResponseSchema: GenMessage<NoteFolderResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 19);

/**
 * @generated from message lvdr.v2.note.NoteFolderListResponse
 */
export type NoteFolderListResponse = Message<"lvdr.v2.note.NoteFolderListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.note.NoteFolder folders = 1;
   */
  folders: NoteFolder[];
};

/**
 * Describes the message lvdr.v2.note.NoteFolderListResponse.
 * Use `create(NoteFolderListResponseSchema)` to create a new message.
 */
export const NoteFolderListResponseSchema: GenMessage<NoteFolderListResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 20);

/**
 * DeleteNoteFolderResponse acks a successful folder delete by id (same
 * rationale as DeleteNoteResponse).
 *
 * @generated from message lvdr.v2.note.DeleteNoteFolderResponse
 */
export type DeleteNoteFolderResponse = Message<"lvdr.v2.note.DeleteNoteFolderResponse"> & {
  /**
   * @generated from field: string folder_id = 1;
   */
  folderId: string;
};

/**
 * Describes the message lvdr.v2.note.DeleteNoteFolderResponse.
 * Use `create(DeleteNoteFolderResponseSchema)` to create a new message.
 */
export const DeleteNoteFolderResponseSchema: GenMessage<DeleteNoteFolderResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 21);

/**
 * Link/Unlink
 *
 * @generated from message lvdr.v2.note.LinkNoteRequest
 */
export type LinkNoteRequest = Message<"lvdr.v2.note.LinkNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string target_type = 2;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 3;
   */
  targetId: string;
};

/**
 * Describes the message lvdr.v2.note.LinkNoteRequest.
 * Use `create(LinkNoteRequestSchema)` to create a new message.
 */
export const LinkNoteRequestSchema: GenMessage<LinkNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 22);

/**
 * @generated from message lvdr.v2.note.UnlinkNoteRequest
 */
export type UnlinkNoteRequest = Message<"lvdr.v2.note.UnlinkNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string target_type = 2;
   */
  targetType: string;

  /**
   * @generated from field: string target_id = 3;
   */
  targetId: string;
};

/**
 * Describes the message lvdr.v2.note.UnlinkNoteRequest.
 * Use `create(UnlinkNoteRequestSchema)` to create a new message.
 */
export const UnlinkNoteRequestSchema: GenMessage<UnlinkNoteRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 23);

/**
 * AI Tools
 *
 * @generated from message lvdr.v2.note.NoteAIRequest
 */
export type NoteAIRequest = Message<"lvdr.v2.note.NoteAIRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * "rewrite", "answer", "organize"
   *
   * @generated from field: string tool = 2;
   */
  tool: string;

  /**
   * @generated from field: string selection = 3;
   */
  selection: string;

  /**
   * @generated from field: string instruction = 4;
   */
  instruction: string;
};

/**
 * Describes the message lvdr.v2.note.NoteAIRequest.
 * Use `create(NoteAIRequestSchema)` to create a new message.
 */
export const NoteAIRequestSchema: GenMessage<NoteAIRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 24);

/**
 * @generated from message lvdr.v2.note.NoteAIResponse
 */
export type NoteAIResponse = Message<"lvdr.v2.note.NoteAIResponse"> & {
  /**
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 2;
   */
  aiMark?: AiMark | undefined;
};

/**
 * Describes the message lvdr.v2.note.NoteAIResponse.
 * Use `create(NoteAIResponseSchema)` to create a new message.
 */
export const NoteAIResponseSchema: GenMessage<NoteAIResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 25);

/**
 * Research Trigger
 *
 * @generated from message lvdr.v2.note.NoteResearchRequest
 */
export type NoteResearchRequest = Message<"lvdr.v2.note.NoteResearchRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string selection = 2;
   */
  selection: string;

  /**
   * @generated from field: string profile_id = 3;
   */
  profileId: string;
};

/**
 * Describes the message lvdr.v2.note.NoteResearchRequest.
 * Use `create(NoteResearchRequestSchema)` to create a new message.
 */
export const NoteResearchRequestSchema: GenMessage<NoteResearchRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 26);

/**
 * @generated from message lvdr.v2.note.NoteResearchResponse
 */
export type NoteResearchResponse = Message<"lvdr.v2.note.NoteResearchResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.note.NoteResearchResponse.
 * Use `create(NoteResearchResponseSchema)` to create a new message.
 */
export const NoteResearchResponseSchema: GenMessage<NoteResearchResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 27);

/**
 * Entity Search (for wikilink autocomplete)
 *
 * @generated from message lvdr.v2.note.SearchNoteEntitiesRequest
 */
export type SearchNoteEntitiesRequest = Message<"lvdr.v2.note.SearchNoteEntitiesRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;
};

/**
 * Describes the message lvdr.v2.note.SearchNoteEntitiesRequest.
 * Use `create(SearchNoteEntitiesRequestSchema)` to create a new message.
 */
export const SearchNoteEntitiesRequestSchema: GenMessage<SearchNoteEntitiesRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 28);

/**
 * @generated from message lvdr.v2.note.SearchNoteEntitiesResponse
 */
export type SearchNoteEntitiesResponse = Message<"lvdr.v2.note.SearchNoteEntitiesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.note.NoteEntity entities = 1;
   */
  entities: NoteEntity[];
};

/**
 * Describes the message lvdr.v2.note.SearchNoteEntitiesResponse.
 * Use `create(SearchNoteEntitiesResponseSchema)` to create a new message.
 */
export const SearchNoteEntitiesResponseSchema: GenMessage<SearchNoteEntitiesResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 29);

/**
 * @generated from message lvdr.v2.note.NoteEntity
 */
export type NoteEntity = Message<"lvdr.v2.note.NoteEntity"> & {
  /**
   * "research", "document", "note", "memory"
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message lvdr.v2.note.NoteEntity.
 * Use `create(NoteEntitySchema)` to create a new message.
 */
export const NoteEntitySchema: GenMessage<NoteEntity> = /*@__PURE__*/
  messageDesc(file_note_note, 30);

/**
 * @generated from message lvdr.v2.note.NoteSnapshot
 */
export type NoteSnapshot = Message<"lvdr.v2.note.NoteSnapshot"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;

  /**
   * the note version this snapshot froze
   *
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * "conflict" | "interval" | "manual" | "pre-restore"
   *
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * sha256 over the frozen content
   *
   * @generated from field: string content_hash = 6;
   */
  contentHash: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.note.NoteSnapshot.
 * Use `create(NoteSnapshotSchema)` to create a new message.
 */
export const NoteSnapshotSchema: GenMessage<NoteSnapshot> = /*@__PURE__*/
  messageDesc(file_note_note, 31);

/**
 * @generated from message lvdr.v2.note.CreateNoteSnapshotRequest
 */
export type CreateNoteSnapshotRequest = Message<"lvdr.v2.note.CreateNoteSnapshotRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * "manual" | "pre-restore" (server stamps the rest)
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.note.CreateNoteSnapshotRequest.
 * Use `create(CreateNoteSnapshotRequestSchema)` to create a new message.
 */
export const CreateNoteSnapshotRequestSchema: GenMessage<CreateNoteSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 32);

/**
 * @generated from message lvdr.v2.note.ListNoteSnapshotsRequest
 */
export type ListNoteSnapshotsRequest = Message<"lvdr.v2.note.ListNoteSnapshotsRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;
};

/**
 * Describes the message lvdr.v2.note.ListNoteSnapshotsRequest.
 * Use `create(ListNoteSnapshotsRequestSchema)` to create a new message.
 */
export const ListNoteSnapshotsRequestSchema: GenMessage<ListNoteSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 33);

/**
 * Reply for BOTH create and list — create resolves with the refreshed list.
 *
 * @generated from message lvdr.v2.note.NoteSnapshotListResponse
 */
export type NoteSnapshotListResponse = Message<"lvdr.v2.note.NoteSnapshotListResponse"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * newest first, metadata only
   *
   * @generated from field: repeated lvdr.v2.note.NoteSnapshot snapshots = 2;
   */
  snapshots: NoteSnapshot[];
};

/**
 * Describes the message lvdr.v2.note.NoteSnapshotListResponse.
 * Use `create(NoteSnapshotListResponseSchema)` to create a new message.
 */
export const NoteSnapshotListResponseSchema: GenMessage<NoteSnapshotListResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 34);

/**
 * @generated from message lvdr.v2.note.GetNoteSnapshotRequest
 */
export type GetNoteSnapshotRequest = Message<"lvdr.v2.note.GetNoteSnapshotRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;
};

/**
 * Describes the message lvdr.v2.note.GetNoteSnapshotRequest.
 * Use `create(GetNoteSnapshotRequestSchema)` to create a new message.
 */
export const GetNoteSnapshotRequestSchema: GenMessage<GetNoteSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_note_note, 35);

/**
 * @generated from message lvdr.v2.note.NoteSnapshotContentResponse
 */
export type NoteSnapshotContentResponse = Message<"lvdr.v2.note.NoteSnapshotContentResponse"> & {
  /**
   * @generated from field: lvdr.v2.note.NoteSnapshot snapshot = 1;
   */
  snapshot?: NoteSnapshot | undefined;

  /**
   * @generated from field: string content = 2;
   */
  content: string;
};

/**
 * Describes the message lvdr.v2.note.NoteSnapshotContentResponse.
 * Use `create(NoteSnapshotContentResponseSchema)` to create a new message.
 */
export const NoteSnapshotContentResponseSchema: GenMessage<NoteSnapshotContentResponse> = /*@__PURE__*/
  messageDesc(file_note_note, 36);

/**
 * LinkOrigin distinguishes user-created links (the "Link entity" panel)
 * from links materialized by the server-side [[wikilink]] parse on save.
 * Wikilink-origin rows are wholesale replaced on every save; manual rows
 * are never touched by that sync.
 *
 * @generated from enum lvdr.v2.note.LinkOrigin
 */
export enum LinkOrigin {
  /**
   * @generated from enum value: LINK_ORIGIN_MANUAL = 0;
   */
  MANUAL = 0,

  /**
   * @generated from enum value: LINK_ORIGIN_WIKILINK = 1;
   */
  WIKILINK = 1,
}

/**
 * Describes the enum lvdr.v2.note.LinkOrigin.
 */
export const LinkOriginSchema: GenEnum<LinkOrigin> = /*@__PURE__*/
  enumDesc(file_note_note, 0);

